/**
 * Generates a cryptographically secure random alphanumeric code.
 * Uses `crypto.getRandomValues()` instead of `Math.random()` to ensure
 * the output is suitable for use in certificate IDs and other security-sensitive contexts.
 *
 * @returns A 6-character uppercase alphanumeric string (e.g. "A3Z9KW")
 */
export function generateSecureRandomCode(): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  const bytes = new Uint8Array(6);
  crypto.getRandomValues(bytes);
  for (let i = 0; i < 6; i++) {
    result += chars[bytes[i] % chars.length];
  }
  return result;
}

/**
 * Formats a certificate code from a vendor prefix and a random part.
 *
 * @param vendor - The vendor identifier (e.g. "OXBRIDGE")
 * @param randomPart - The random portion of the code (e.g. from generateSecureRandomCode())
 * @returns A formatted certificate code string (e.g. "OXBRIDGE-A3Z9KW")
 */
export function formatCertificateCode(
  vendor: string,
  randomPart: string,
): string {
  return `${vendor}-${randomPart}`;
}
